module.exports = __webpack_public_path__ + "img/LT300087289.06b2349d.png";